import { render, staticRenderFns } from "./ManejoConsultasExternas.vue?vue&type=template&id=6db83f48"
import script from "./ManejoConsultasExternas.vue?vue&type=script&lang=js"
export * from "./ManejoConsultasExternas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports